// 🎯 Adaptador de API para la recepción de devoluciones - API adapter for returned items reception
import { HttpClient } from '@shared/adapters/HttpClient';
import { ReceiveReturnedModel, ReceiveReturnedResponse } from '../models';

export class ReceiveApiAdapter {
  constructor(private httpClient: HttpClient) {}

  // 🎯 Obtener datos de la recepción por ID
  async getReceiveReturnedById(id: number): Promise<ReceiveReturnedModel> {
    try {
      return await this.httpClient.get<ReceiveReturnedModel>(`/returned-receptions/${id}`);
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Recepcionar líneas de devolución
  async receiveReturnedLines(
    id: number,
    data: {
      order_id: number;
      lines: Array<{ product_id: number; quantity: number; batch_id?: number }>;
    },
  ): Promise<ReceiveReturnedResponse> {
    try {
      return await this.httpClient.post<ReceiveReturnedResponse>(`/returned-receptions/${id}/receive`, data);
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error en recepción:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Ubicar líneas de devolución
  async locateReturnedLines(
    id: number,
    data: {
      lines: Array<{
        product_id: number;
        quantity: number;
        location_id: number;
      }>;
    },
  ): Promise<ReceiveReturnedResponse> {
    try {
      return await this.httpClient.post<ReceiveReturnedResponse>(`/returned-receptions/${id}/locate`, data);
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error en ubicación:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Asignar carrito a una recepción de devolución
  async assignCartToReception(id: number, data: { cart_code: string }): Promise<ReceiveReturnedResponse> {
    try {
      return await this.httpClient.post<ReceiveReturnedResponse>(`/returned-receptions/${id}/cart`, data);
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error al asignar carrito:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Finalizar una recepción de devolución
  async finalizeReception(id: number): Promise<ReceiveReturnedResponse> {
    try {
      return await this.httpClient.put<ReceiveReturnedResponse>(`/returned-receptions/${id}/finalize`, {});
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error al finalizar:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }
}
